import FoundryLink from "../../components/FoundryLink";
import FoundryPhysicalProduct from "../../lib/foundry_client/models/FoundryPhysicalProduct";
import { LineItem } from "../../lib/models/LineItems";
import ResponsiveImage from "../ResponsiveImage";
import Routes from "../../routes";
import { formatMoneyShort } from "../../util/strings";
import useQuantitySelect from "../../hooks/useQuantitySelect";

export default function PhysicalLineItemSection({
  item,
  productDetails,
}: {
  item: LineItem;
  productDetails: FoundryPhysicalProduct | undefined;
}) {
  const [quantitySelector] = useQuantitySelect(
    0,
    item.quantity,
    (n: number) => {},
    true
  );

  return (
    <>
      <div className="flex flex-row justify-between opacity-100 transition-opacity">
        <div className="flex flex-row gap-8">
          <div className="w-24">
            {productDetails && (
              <FoundryLink href={Routes.shop.product(productDetails.slug)}>
                <ResponsiveImage
                  src={productDetails.profileImages[0].fileUrl}
                  alt={productDetails.profileImages[0].description}
                  sizes="80px"
                  roundedBorder={8}
                ></ResponsiveImage>
              </FoundryLink>
            )}
          </div>
          <div className="flex flex-col gap-3">
            <span>
              <FoundryLink
                href={Routes.shop.product(productDetails?.slug)}
                className="color-blue-hover"
              >
                {item.name}
              </FoundryLink>
            </span>
            {quantitySelector}
          </div>
        </div>
        <div className="flex flex-row gap-2">
          <span
            className={`${
              item.discountCents ? "line-through opacity-50 ml-4" : "ml-4"
            }`}
          >
            {formatMoneyShort("USD", item.price)}
          </span>
          {!!item.discountCents && (
            <span className="ml-4 color-green">
              {formatMoneyShort("USD", item.price - item.discountCents)}
            </span>
          )}
        </div>
      </div>
    </>
  );
}
